/**
 * При клике по ссылке <a> кинем событие
 * number с данными из data из тега
 */

const debug = window.debug

function onClick (e) {

      console.log('onClick', e);
  if ( e.target.nodeName === 'A' ) {
    e.preventDefault()
    var data = JSON.parse( e.target.dataset.data )
      console.log('onClick', data);
    this.$dispatch('number', data)
  }
}

export default {methods: {onClick: onClick}}



/** WEBPACK FOOTER **
 ** ./src/js/lib/methods/onClick.js
 **/